<template>
  <section
    id="case"
    class="py-[3.25rem] md:pb-20 md:pt-10"
  >
    <div class="co-container-lg px-7 sm:px-[3.75rem] lg:px-4">
      <h2 class="co-heading-2 mb-[3.25rem] text-center font-bold">
        <span class="co-display-14 mb-1 inline-block border-b pb-1 font-bold text-[#1ca7f6]">
          Case
        </span>
        <br>
        受講した方の事例
      </h2>
      <div class="flex flex-col items-start justify-center gap-8 sm:items-center md:flex-row md:items-center lg:items-start lg:gap-10">
        <div class="te-case-item sm:w-3/4 md:w-auto">
          <div class="mb-2 flex flex-row items-center justify-start md:flex-col md:justify-center lg:flex-row">
            <img
              src="~/assets/images/Te/TeBenefits/Reskilling/Case/case-at.png"
              width="60"
              height="60"
              alt="A・Tさん"
              loading="lazy"
            >
            <div class="ml-5 md:ml-0 lg:ml-5">
              <span class="co-display-13 mb-1 inline-block bg-[#1ca7f6] px-2 font-bold text-white">
                副業事例
              </span>
              <h3 class="co-display-10 co-line-height-one-point-five font-bold">
                仕事を続けながら副業を実現
              </h3>
              <p class="co-display-13 text-co-gray-600">
                <span class="mr-3">
                  A・Tさん
                </span>
                はじめての副業コース
              </p>
            </div>
          </div>
          <p class="text-co-gray-600">
            将来も役立つ、在宅でもできるスキルとしてWeb制作を選択。受講後案件を一緒に取り組み月10万を稼ぐまでに
          </p>
        </div>
        <div class="te-case-item sm:w-3/4 md:w-auto">
          <div class="mb-2 flex flex-row items-center justify-start md:flex-col md:justify-center lg:flex-row">
            <img
              src="~/assets/images/Te/TeBenefits/Reskilling/Case/case-komori.png"
              width="60"
              height="60"
              alt="小森 弘貴さん"
              loading="lazy"
            >
            <div class="ml-5 md:ml-0 lg:ml-5">
              <span class="co-display-13 mb-1 inline-block bg-[#1ca7f6] px-2 font-bold text-white">
                転職・副業事例
              </span>
              <h3 class="co-display-10 co-line-height-one-point-five font-bold">
                転職も副業も実現
              </h3>
              <p class="co-display-13 text-co-gray-600">
                <span class="mr-3">
                  小森 弘貴さん
                </span>
                Webデザインコース
              </p>
            </div>
          </div>
          <p class="text-co-gray-600">
            独学での不安から受講を決意。Web制作会社に転職、さらに副業案件を受注し、満足感のある生活を実現
          </p>
        </div>
        <div class="te-case-item sm:w-3/4 md:w-auto">
          <div class="mb-2 flex flex-row items-center justify-start md:flex-col md:justify-center lg:flex-row">
            <img
              src="~/assets/images/Te/TeBenefits/Reskilling/Case/case-kakiuchi.png"
              width="60"
              height="60"
              alt="垣内 晴賀さん"
              loading="lazy"
            >
            <div class="ml-5 md:ml-0 lg:ml-5">
              <span class="co-display-13 mb-1 inline-block bg-[#1ca7f6] px-2 font-bold text-white">
                転職事例
              </span>
              <h3 class="co-display-10 co-line-height-one-point-five font-bold">
                未経験から在宅ワークを実現
              </h3>
              <p class="co-display-13 text-co-gray-600">
                <span class="mr-3">
                  垣内 晴賀さん
                </span>
                Webデザインコース
              </p>
            </div>
          </div>
          <p class="text-co-gray-600">
            営業から、オンラインでの学習を経て、Web制作会社へ転職。在宅ワークで子どもにおかえりと言える環境に
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.te-case-item {
  background-image: url('~/assets/images/Te/TeBenefits/Reskilling/Case/bg-case-text.svg');
  background-repeat: no-repeat;
  background-position: top right;
  background-size: contain;
}
</style>
